/**
 * Step 9 — Day 1 streak intro
 *
 * Spec: specs/onboarding-rebuild.md → Act 2 step 9
 *
 * Variant scaffolding retired 2026-05-14 — synthesis is production.
 */

import StreakIntroSynthesis from './StreakIntro.synthesis'

export default function StreakIntroStep({ displayName = 'friend', firstName, onContinue }) {
  return (
    <StreakIntroSynthesis displayName={displayName} firstName={firstName} onContinue={onContinue} />
  )
}
